// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import smoothscroll from 'smoothscroll-polyfill'
import 'bootstrap-vue/dist/bootstrap-vue.css'

smoothscroll.polyfill()

Vue.config.productionTip = false

if (process.env.NODE_ENV === 'production') {
  Vue.prototype.$api = '/api'
} else {
  Vue.prototype.$api = 'http://localhost:8000/api'
}
Vue.use(BootstrapVue)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js